<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M2 12l3.077-3.2 4.615 4.8L18.923 4 22 7.2 9.692 20 2 12z"/></svg>